import { PDFDocument, rgb } from 'pdf-lib';
import { ENDPOINT } from 'constants/variables';

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

export const fetchFormDIDecaQr = async (formdiId, token) => {
  if (!formdiId) return '';
  try {
    const response = await fetch(
      `${ENDPOINT}/deca/documents/formdi/${formdiId}/qr`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (response.status === 204) return '';
    if (!response.ok) return '';
    return blobToDataUrl(await response.blob());
  } catch {
    return '';
  }
};

export const addFormDIDecaQrToPdf = async (pdfBlob, qrDataUrl) => {
  if (!pdfBlob || !qrDataUrl) return pdfBlob;
  const pdf = await PDFDocument.load(await pdfBlob.arrayBuffer());
  const qr = await pdf.embedPng(qrDataUrl);
  const firstPage = pdf.getPages()[0];
  const size = 54;
  const padding = 4;
  const x = firstPage.getWidth() - 95;
  const y = firstPage.getHeight() - 66;
  firstPage.drawRectangle({
    x: x - padding,
    y: y - padding,
    width: size + (padding * 2),
    height: size + (padding * 2),
    color: rgb(1, 1, 1),
  });
  firstPage.drawImage(qr, {
    x,
    y,
    width: size,
    height: size,
  });
  return new Blob([await pdf.save()], { type: 'application/pdf' });
};
